import { useState } from 'react';
import toast from 'react-hot-toast';

export default function ExportButton({ year }) {
  const [loading, setLoading] = useState(false);

  async function handleExport() {
    setLoading(true);
    try {
      const token = localStorage.getItem('cpr_token');
      const params = year ? `?year=${year}` : '';
      const response = await fetch(`/api/export${params}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Export failed');
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Amanda_Export_${new Date().toISOString().slice(0,10)}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success('Excel file downloaded!');
    } catch (err) {
      toast.error(err.message || 'Export failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <button className="btn btn-outline" onClick={handleExport} disabled={loading}>
      <svg viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd"/>
      </svg>
      {loading ? 'Exporting…' : 'Export Excel'}
    </button>
  );
}
